<template>
  <div
    class="adn-checkbox"
    :class="{
      'adn-checkbox--disabled': disabled,
    }"
    @click.stop="onClick"
  >
    <input ref="input" type="checkbox" :checked="checked" class="adn-checkbox__input" />
    <span
      class="adn-icon adn-checkbox__checkbox adn-icon--status-check"
      :class="{ 'adn-checkbox__checkbox--disabled': disabled }"
      aria-hidden="true"
    />
    <label data-label-test class="adn-checkbox__label" :class="{ 'adn-checkbox__checkbox--disabled': disabled }">
      <!-- @slot Label next to the checkbox -->
      <slot></slot>
    </label>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AdnCheckbox',
  props: {
    checked: {
      type: [Boolean],
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    trueValue: {
      default: true,
    },
    falseValue: {
      default: false,
    },
  },
  methods: {
    onClick() {
      if (this.disabled) {
        return
      }
      if (this.$refs.input) {
        // @ts-expect-error soucis avec Vue2 sur les refs
        this.$refs.input.checked = !this.$refs.input?.checked
      }
      /**
       * 'change' event. emits the value stored in trueValue or falseValue
       *
       * @event change
       * @type {any}
       */
      // @ts-expect-error soucis avec Vue2 sur les refs
      this.$emit('change', this.$refs.input?.checked ? this.trueValue : this.falseValue)
    },
  },
})
</script>

<style scoped lang="scss">
.adn-checkbox {
  display: inline-block;
  position: relative;
  height: 2.4rem;
  cursor: pointer;

  .adn-checkbox__input {
    display: none;

    + .adn-checkbox__checkbox {
      transition: color 0.5s ease;
    }

    &:checked + .adn-checkbox__checkbox {
      border-color: var(--color-main);
      color: var(--color-white);
      background-color: var(--color-main);
    }

    &:checked ~ .adn-checkbox__label {
      color: var(--color-main);
      font-weight: bold;
    }
  }

  &--disabled {
    cursor: default;
    color: var(--color-inactive-dark);

    .adn-checkbox__input {
      &:checked + .adn-checkbox__checkbox {
        border-color: var(--color-inactive-dark);
        background-color: var(--color-inactive-dark);
        color: var(--color-white);
      }

      &:checked ~ .adn-checkbox__label {
        font-weight: bold;
      }
    }
  }

  .adn-checkbox__checkbox {
    position: absolute;
    width: 2rem;
    height: 2rem;
    display: inline-block;
    border: 1px solid var(--color-text-light);
    border-radius: 2px;
    color: var(--color-background-light);
    background-color: var(--color-background-light);
    top: 50%;
    transform: translateY(-50%);

    &:hover:not(.adn-checkbox__checkbox--disabled) {
      transition: border-color 0.5s ease;
      border-color: var(--color-main);
    }

    &:not(:hover) {
      transition: border-color 0.5s ease;
    }

    &--disabled {
      border-color: var(--color-inactive-light);
    }
  }

  .adn-checkbox__label {
    cursor: pointer;
    margin-left: 2.9rem;
    line-height: 2.4rem;
  }
}

:deep(.adn-icon::before) {
  position: absolute;
  top: -2px;
  left: -3px;
}
</style>
